import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Play, ArrowRight } from "lucide-react";

const BANNER = "/brand/hero_banner.png";

export default function BrandHero({ featured }) {
  const { user } = useAuth();

  return (
    <section
      data-testid="brand-hero"
      className="relative min-h-[88vh] w-full flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img src={BANNER} alt="Mandalay+ — Burmese cinema" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/75 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-transparent to-ink/30" />
      </div>

      <div className="relative z-10 px-4 sm:px-10 lg:px-16 max-w-3xl animate-fade-up">
        <span className="inline-block text-[11px] sm:text-xs uppercase tracking-[0.3em] text-gold/90 mb-5">
          Entertainment · Culture · Connection
        </span>
        <h1 className="font-display font-bold text-5xl sm:text-6xl lg:text-7xl leading-[0.92] tracking-tight">
          Mandalay<span className="text-brand">+</span>
        </h1>
        <p className="font-display text-xl sm:text-2xl text-gold mt-4">
          Premium Burmese Cinema — Rent or Buy.
        </p>
        <p className="text-white/70 text-base sm:text-lg leading-relaxed mt-5 max-w-xl">
          Stream hand-picked Myanmar movies and series in stunning HD &amp; 4K.
          No subscription — sign up free and pay only for what you watch.
        </p>

        <div className="flex flex-wrap items-center gap-4 mt-9">
          <Link
            to="/browse"
            data-testid="hero-browse-btn"
            className="bg-gold text-ink font-medium px-8 py-3 rounded-sm hover:bg-gold-bright transition-colors inline-flex items-center gap-2"
          >
            <Play className="w-5 h-5 fill-ink" strokeWidth={1.5} /> Browse Films
          </Link>
          {!user ? (
            <Link
              to="/register"
              data-testid="hero-signup-btn"
              className="border border-gold/40 text-gold px-8 py-3 rounded-sm hover:bg-gold/10 transition-colors inline-flex items-center gap-2"
            >
              Sign Up Free <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
          ) : (
            featured && (
              <Link
                to={`/title/${featured.id}`}
                data-testid="hero-featured-btn"
                className="border border-white/15 text-white/80 px-8 py-3 rounded-sm hover:border-white/40 transition-colors inline-flex items-center gap-2"
              >
                Featured: {featured.title}
              </Link>
            )
          )}
        </div>
      </div>
    </section>
  );
}
